import MainButton from '@/components/ui/custom/buttons/MainButton';
import ComponentGuard from '@/components/ui/custom/ComponentGuard';
import Tag from '@/components/ui/custom/dataDisplay/Tag';
import HackathonService from '@/components/projects/hackathon/form/HackathonService';
import {
  hackathonsQueryKeys,
  hackathonsStagesQueryKeys,
} from '@/data/services/querykeys';
import Hackathon from '@/models/Hackathon';
import { UserTypeEnum } from '@/models/User';
import { InformationCircleIcon, PencilIcon } from '@heroicons/react/24/outline';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface EditKlassProps {
  hackathon: Hackathon;
}

export default function EditHackathon({ hackathon }: EditKlassProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'manageKlasses.addKlass',
  });
  const [editMode, setEditMode] = useState(false);

  const queryClient = useQueryClient();

  const onSuccess = async () => {
    await Promise.all([
      queryClient.invalidateQueries({
        queryKey: hackathonsQueryKeys.list._def,
      }),
      queryClient.invalidateQueries({
        queryKey: hackathonsStagesQueryKeys.list._def,
      }),
    ]);
  };
  return (
    <div className="flex flex-col w-full font-rubik pt-5 pb-5 ml-8">
      <div className="flex w-auto items-center gap-8 mb-3 ">
        <Tag
          text={t('info')}
          icon={<InformationCircleIcon className="w-6 h-6" />}
        />
        <ComponentGuard roles={[UserTypeEnum.SUPER_ADMIN]}>
          <MainButton
            disabled={editMode}
            onClick={() => setEditMode(true)}
            text={t('edit')}
            icon={<PencilIcon />}
            color="custom"
            className="text-primary"
            dataTestId="editButton"
          />
        </ComponentGuard>
      </div>
      <HackathonService
        hackathon={hackathon}
        disable={!editMode}
        onCancel={() => setEditMode(false)}
        onSucess={onSuccess}
      />
    </div>
  );
}
